import React, { useRef, useState } from "react";
import "./index.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import UserAddedCIP from "../components/AddCIPAndShutdown";
import PlantInformation from "../pages/plantPage/plantInformation";
import CostInformation from "../pages/costInformation";
import DefaultCIPInformation from "../pages/defaultCIPInformation";
import { DEFAULT_CIP_KEYS } from "../constants/global.constants";
import IdentifyCIP from "../pages/home/identifyCIP";
import { useSelector, useDispatch } from "react-redux";
import Settings from "../pages/home/Settings";
import HistoricalCIPEffectivness from "../pages/historialCIPsEffectivness";
import FoulingIdentification from "../pages/foulingIdentification";
import PredictCIP from "../pages/predict";
import { getDuplicateItems } from "../utils/Utils";
import { storeFoulingType } from "../Store/TemplateStore/template.action";
import { getfoulingType } from "../network/cipAPI";

const XLSFileUpload = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const {
    activeStep,
    setActiveStep,
    isFirstTimeLoad,
    isBackClicked,
    setIsBackClicked,
    setDisableNextButton,
  } = props;
  const [file_id, setFileId] = useState(useSelector((state) => state.file_id));
  const cips = useSelector((state) => state.cips);
  const [duplicateCip, setDuplicateCip] = useState(false);
  const [noCostError, setNoCostError] = useState(true);
  const [noDefaultError, setNoDefaultError] = useState(true);

  const fileRef = useRef(null);
  const plantRef = useRef(null);
  const costRef = useRef(null);
  const defaultInfo = useRef(null);
  const settingsRef = useRef(null);

  const onNextClicked = async () => {
    if (activeStep === 1) {
      const response = await getfoulingType();
      if (response && response.data) dispatch(storeFoulingType(response.data));
      const cipCopy = { ...cips };
      const cipsStartDate = Object.values(cipCopy).map(
        (item) => item.start_date
      );
      const duplicateCips = getDuplicateItems(cipsStartDate);
      setDuplicateCip(duplicateCips);
      if (duplicateCips.length <= 0) {
        setActiveStep(activeStep + 1);
      }
    } else if (noCostError) {
      if (settingsRef && settingsRef.current) {
        settingsRef.current.settingsInformation();
      }
      if (fileRef && fileRef.current) {
        fileRef.current.performanceData();
      }
      if (costRef && costRef.current) {
        costRef.current.costInformation();
      }
      if (plantRef && plantRef.current) {
        plantRef.current.plantInformation();
      }
    }
  };

  React.useImperativeHandle(ref, () => ({ onNextClicked }));

  return (
    <div>
      {activeStep === 0 && (
        <div className="uploadContainer">
          {/* <PerformanceData
            fileId={file_id}
            setFileId={setFileId}
            setActiveStep={setActiveStep}
            ref={fileRef}
          /> */}
          <PlantInformation
            ref={plantRef}
            setActiveStep={setActiveStep}
            mandatoryThresholdFilled={true}
          />
          <Settings
            ref={settingsRef}
            fileId={file_id}
            isBackClicked={isBackClicked}
            disabled={true}
          />
          <CostInformation
            ref={costRef}
            fileId={file_id}
            setActiveStep={setActiveStep}
            setNoCostError={setNoCostError}
            isBackClicked={isBackClicked}
            setIsBackClicked={setIsBackClicked}
          />
          <DefaultCIPInformation
            defaultCIPKeys={DEFAULT_CIP_KEYS}
            disabled
            ref={defaultInfo}
            setActiveStep={setActiveStep}
          />
          <div style={{ marginTop: "20px" }}>
            <UserAddedCIP isFirstTimeLoad={isFirstTimeLoad} />
          </div>
        </div>
      )}
      {activeStep === 1 && (
        <IdentifyCIP
          duplicateCip={duplicateCip}
          setDuplicateCip={setDuplicateCip}
          activeStep={activeStep}
        />
      )}
      {activeStep === 2 && (
        <HistoricalCIPEffectivness activeStep={activeStep} />
      )}
      {activeStep === 3 && <FoulingIdentification activeStep={activeStep} />}
      {activeStep === 4 && (
        <PredictCIP setDisableNextButton={setDisableNextButton} />
      )}
    </div>
  );
});

export default XLSFileUpload;
